<div class="container-fluid mt-3 mb-3">
  <div class="row mt-3 mb-3">
    <div class="col-12 mb-3">
      <form [formGroup]="eventForm" (ngSubmit)="submitForm()" class="container-fluid mt-4">

        <!-- Row 1 -->
        <div class="row g-3">
          <div class="col-lg-3 col-md-6 col-12">
            <div class="form-floating">
              <input type="text" class="form-control" value="வாழ்வை மாற்றும் வேல் மாறல்" readonly>
              <label>Event Name <span class="text-danger">*</span></label>
              <div *ngIf="f.eventName.touched && f.eventName.invalid" class="text-danger">
                Event name is required
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-12">
            <div class="form-floating">
              <select class="form-select" formControlName="state" (change)="loadDistricts($any($event.target).value)">
                <option value="" disabled selected>Select any one</option>
                <option *ngFor="let s of statesList" [value]="s.value">{{ s.label }}</option>
              </select>
              <label>State / UT <span class="text-danger">*</span></label>
              <div *ngIf="f.state.touched && f.state.invalid" class="text-danger">
                State is required
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-12">
            <div class="form-floating">
              <select class="form-select" formControlName="city">
                <option value="" disabled selected>Select any one</option>
                <option *ngFor="let d of districtList" [value]="d.value">{{ d.label }}</option>
              </select>
              <label>District <span class="text-danger">*</span></label>
              <div *ngIf="f.city.touched && f.city.invalid" class="text-danger">
                District is required
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-12">
            <div class="form-floating">
              <input type="text" class="form-control" formControlName="eventVenue">
              <label>Venue <span class="text-danger">*</span></label>
              <div *ngIf="f.eventVenue.touched && f.eventVenue.invalid" class="text-danger">
                Venue is required
              </div>
            </div>
          </div>
        </div>

        <!-- Row 2 -->
        <div class="row g-3 mt-1">
          <div class="col-lg-3 col-md-6 col-12">
            <div class="form-floating">
              <input type="number" class="form-control" formControlName="bookingCount" min="1"
                (keydown)="allowNumbersOnly($event)">
              <label>Overall Booking Count <span class="text-danger">*</span></label>
              <div *ngIf="f.bookingCount.touched && f.bookingCount.invalid" class="text-danger">
                Must be at least 1
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-12">
            <div class="form-floating">
              <input type="date" class="form-control" formControlName="eventDate">
              <label>Event Date <span class="text-danger">*</span></label>
              <div *ngIf="f.eventDate.touched && f.eventDate.invalid" class="text-danger">
                Event date is required
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-12">
            <div class="form-floating">
              <input type="time" class="form-control" formControlName="startTime">
              <label>Event Start Time</label>
              <div *ngIf="f.startTime.touched && f.startTime.invalid" class="text-danger">
                Start time is required
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-12">
            <div class="form-floating">
              <input type="time" class="form-control" formControlName="endTime">
              <label>Event End Time</label>
              <div *ngIf="f.endTime.touched && f.endTime.invalid" class="text-danger">
                End time is required
              </div>
            </div>
          </div>

        </div>

        <!-- Row 3 -->
        <div class="row g-3 mt-1">

          <div class="col-lg-3 col-md-6 col-12">
            <div class="form-floating">
  <input type="date" class="form-control" formControlName="startDate">
  <label>Registration Opening Date <span class="text-danger">*</span></label>

  <div *ngIf="f.startDate.touched && f.startDate.invalid" class="text-danger">
    <div *ngIf="f.startDate.errors?.required">Registration Opening Date is required</div>
    <div  *ngIf="f.startDate.errors?.startGreaterEnd">
  Opening Date must be less than Closing Date
</div>
    <div *ngIf="f.startDate.errors?.invalidStart">Opening Date must be earlier than Event Date</div>
  </div>
</div>

          </div>

          <div class="col-lg-3 col-md-6 col-12">
<div class="form-floating">
  <input type="date" class="form-control" formControlName="endDate">
  <label>Registration Close Date <span class="text-danger">*</span></label>

  <div *ngIf="f.endDate.touched && f.endDate.invalid" class="text-danger">
    <div *ngIf="f.endDate.errors?.required">Registration Close Date is required</div>
    <div *ngIf="f.endDate.errors?.invalidEnd">Closing Date must be earlier than Event Date</div>
  </div>
</div>

          </div>

          <div class="col-lg-3 col-md-6 col-12">
            <div class="form-floating">
              <input type="text" class="form-control" formControlName="ticketPrefix" maxlength="3"
                placeholder="Example: MDU, CHN" pattern="[A-Za-z]*" (input)="toUppercase('ticketPrefix')" [readonly]="eventDetails?.isTicketRegistered">
              <label>Event Ticket Series Tag (Eg: MDU, CHN) <span class="text-danger">*</span></label>

              <div *ngIf="f.ticketPrefix.touched && f.ticketPrefix.invalid" class="text-danger">
                Event Ticket Series No is required and must contain only letters (A–Z).
              </div>
            </div>
          </div>

        </div>

        <!-- Row 4 -->
        <div class="row g-3 mt-1">
        </div>

        <!-- Row 5 - Map Link -->
        <div class="row g-3 mt-1">
          <div class="col-lg-6 col-12">
            <div class="form-floating">
              <input class="form-control" formControlName="mapEmbeddedLink">
              <label>Venue Map Link <span class="text-danger">(Event Venue Map Link)</span></label>
              <div *ngIf="f.mapEmbeddedLink.touched && f.mapEmbeddedLink.invalid" class="text-danger">
                Map link is required
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-12">
            <div class="form-floating">
              <input class="form-control" formControlName="whatsappGroupLink">
              <label>Whatsapp Group Link <span class="text-danger">*</span></label>
              <div *ngIf="f.whatsappGroupLink.touched && f.whatsappGroupLink.invalid" class="text-danger">
                Whatsapp Group Link is required
              </div>
            </div>
          </div>

        </div>

        <!-- Row 6: Description -->
        <div class="card shadow-sm mt-3">
          <div class="card-body">

            <div class="row g-3">
              <div class="col-12">

                <label class="fw-bold mb-2">Enter Event Description</label>
                <br>
                <quill-editor class="quill-box" formControlName="termsAndCondition"
                  placeholder="Type description here..."></quill-editor>
                <div *ngIf="f.termsAndCondition.touched && f.termsAndCondition.invalid" class="text-danger">
                  Terms and condition required required
                </div>
              </div>
            </div>

          </div>
        </div>


        <!-- Submit -->
        <div class="row mt-4">
          <div class="col-12 text-center">
            <button type="submit" class="btn btn-success">{{!this.isEdit ? "Save" : "Update"}}</button>
          </div>
        </div>

      </form>

    </div>
  </div>
</div>